import { render, staticRenderFns } from "./ErrorNotFound.vue?vue&type=template&id=356add01&scoped=true"
import script from "./ErrorNotFound.vue?vue&type=script&lang=js"
export * from "./ErrorNotFound.vue?vue&type=script&lang=js"
import style0 from "./ErrorNotFound.vue?vue&type=style&index=0&id=356add01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356add01",
  null
  
)

export default component.exports